import axios from '@utils/axios-client'

export function getPresignUrl (params: any) {
  return axios.put('/api/v1/File/presignedUrl', params).then(response => response.data.data)
}

export function uploadFileS3 (params: any) {
  return fetch(params.url, { method: 'PUT', body: params.data, headers: { 'Content-Type': params.fileType } })
}
